"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * oai-api
 * The OptionsAI API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: tech@options.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 *
 */
class RegistrationApi extends runtime.BaseAPI {
    /**
     * Re-sends an activation email
     */
    activateRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.activation === null || requestParameters.activation === undefined) {
                throw new runtime.RequiredError('activation', 'Required parameter requestParameters.activation was null or undefined when calling activate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/registrations`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ActivationToJSON(requestParameters.activation),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Re-sends an activation email
     */
    activate(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.activateRaw(requestParameters);
        });
    }
    /**
     * Registers an email and starts the activation process
     * Register an email
     */
    registerRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.registration === null || requestParameters.registration === undefined) {
                throw new runtime.RequiredError('registration', 'Required parameter requestParameters.registration was null or undefined when calling register.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/registrations`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.RegistrationToJSON(requestParameters.registration),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Registers an email and starts the activation process
     * Register an email
     */
    register(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.registerRaw(requestParameters);
        });
    }
}
exports.RegistrationApi = RegistrationApi;
